<template>
  <div class="hris-page">
    <div class="hris-page-inner">
      <div class="hris-page-header">
        <span class="hris-page-eyebrow">Online Forms</span>
        <h1 class="hris-page-title">Set Application Approvers</h1>
        <p class="hris-page-subtitle">Assign or update the online form approver for each employee.</p>
      </div>

      <q-form ref="vForm" @submit="onSubmitSearch" class="hris-toolbar">
        <div class="hris-form-field" style="flex: 1 1 280px; max-width: 400px;">
          <q-input :rules="[formRules.required]" outlined v-model="searchModel" dense placeholder="Search employee here..." color="green">
            <template v-slot:append>
              <q-icon name="fa fa-search" />
            </template>
          </q-input>
        </div>
        <q-btn unelevated class="hris-q-primary" label="Search" type="submit"></q-btn>
      </q-form>

      <div class="hris-panel">
        <q-table title="Search Result" flat :data="searchResultData" :columns="searchResultColumns" row-key="id"  :loading="loading" :pagination="initialPagination">
          <q-tr slot="body" slot-scope="props" :props="props">
            <q-td key="employee_id" :props="props">{{ props.row.employee_id }}</q-td>
            <q-td key="name" :props="props">{{ props.row.name }}</q-td>
            <q-td key="position" :props="props">{{ props.row.position }}</q-td>
            <q-td key="department" :props="props">{{ props.row.department }}</q-td>
            <q-td key="approver" :props="props">{{ props.row.approverName }}</q-td>
            <q-td key="action" :props="props">
              <div v-if="props.row.approverName === 'None'">
                <q-btn unelevated class="hris-q-primary" label="Set Approver" @click="listApprover('setApprover','',props.row.id)" no-caps></q-btn>
              </div>
              <div v-else>
                <q-btn unelevated class="hris-q-outline" label="Edit Approver" @click="listApprover('editApprover',props.row.approverID, props.row.id)" no-caps></q-btn>
              </div>
            </q-td>
          </q-tr>
          <template v-slot:no-data="{ message }">
            <div class="hris-empty full-width">{{ message }}</div>
          </template>
        </q-table>
      </div>

      <q-dialog v-model="setApproverDialog" persistent>
        <div class="hris-modal">
          <div class="hris-modal-header">
            <div>
              <h2 class="hris-modal-title">Set Approver</h2>
              <p class="hris-modal-subtitle">Choose the approver for this employee</p>
            </div>
          </div>
          <div class="hris-modal-body">
            <q-list v-for="approver in approvers" :key="approver.id">
              <q-item tag="label">
                <q-item-section avatar>
                  <q-radio v-model="form.selectedApproverID" :val="approver.id" color="green"></q-radio>
                </q-item-section>
                <q-item-section>
                  <q-item-label>{{ approver.name }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </div>
          <div class="hris-modal-footer">
            <q-btn unelevated class="hris-q-outline" label="Cancel" v-close-popup no-caps></q-btn>
            <q-btn unelevated class="hris-q-primary" label="Confirm" @click="setApprover" no-caps></q-btn>
          </div>
        </div>
      </q-dialog>
    </div>

    <q-dialog v-model="loadingModel" persistent>
      <div class="hris-loading" style="background: transparent; min-width: 200px;">
        <q-spinner color="green" size="3em"></q-spinner>
        <div>{{ loadingMessage }}</div>
      </div>
    </q-dialog>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'SetApprovers_Form',
  data() {
    return {
      initialPagination: {
        rowsPerPage: 100
      },
      loadingModel: false,
      loading: false,
      searchModel: null,
      searchResultData: [],
      searchResultColumns: [{
          name: 'employee_id',
          field: 'employee_id',
          label: 'Employee ID',
          style: 'width: 160px',
          align: 'center',
          headerStyle: 'width: 160px'
        },
        {
          name: 'name',
          field: 'name',
          label: 'Name',
          style: 'width: 230px',
          align: 'center',
          headerStyle: 'width: 230px'
        },
        {
          name: 'position',
          field: 'position',
          label: 'Position',
          style: 'width: 250px',
          align: 'center',
          headerStyle: 'width: 250px'
        },
        {
          name: 'department',
          field: 'department',
          label: 'Department',
          style: 'width: 200px',
          align: 'center',
          headerStyle: 'width: 200px'
        },
        {
          name: 'approver',
          field: 'approver',
          label: 'Approver',
          align: 'center'
        },
        {
          name: 'action',
          field: 'action',
          label: 'Action',
          style: 'width: 250px',
          align: 'center',
          headerStyle: 'width: 250px'
        },
      ],
      loadingMessage: '',
      approvers: [],
      selectedApproverID: '',
      setApproverDialog: false,
      form: {
        approveType: '',
        selectedEmployeeID: '',
        selectedApproverID: ''
      }
    }
  },
  methods: {
    onSubmitSearch: function() {
      this.loading = true;
      this.$refs.vForm.validate();

      axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        })
        .get('/online-forms/applications/search-approvers', {
          params: {
            keyword: this.searchModel
          }
        })
        .then((res) => {
          this.loading = false;
          this.searchResultData = [];
          for (let emp of res.data.data) {
            this.searchResultData.push({
              id: emp.online_form_id,
              name: this.toTitleCase(emp.name),
              employee_id: emp.employee_id,
              position: emp.position,
              department: emp.department,
              approverName: emp.approver,
              approverID: emp.approverID
            });
          }
        })
    },

    listApprover: function(approveType, approverID, applicantID) {
      this.form.approveType = approveType;
      this.form.selectedEmployeeID = applicantID;
      this.loadingMessage = 'Getting List of Approvers';
      this.loadingModel = true;
      axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        })
        .get('/online-forms/applications/approvers-list', {
          params: {
            applicantID: applicantID
          }
        })
        .then((res) => {
          this.approvers = [];
          for (let aprv of res.data.data) {
            this.approvers.push({
              name: this.toTitleCase(aprv.name),
              id: aprv.id
            });
          }
          this.loadingModel = false;
          this.form.selectedApproverID = approverID;
          this.setApproverDialog = true;
        })
    },

    setApprover: function() {
      this.loadingMessage = 'Setting Approver';
      this.loadingModel = true;

      if (!this.form.selectedApproverID) {
        this.loadingModel = false;
        this.$q.notify({
          color: 'red-6',
          textColor: 'white',
          icon: 'fa fa-exclamation-circle',
          message: 'Please select approver from the list'
        });
      } else {
        this.setApproverDialog = false;
        let formData = new FormData();
        formData.append('form_data', JSON.stringify(this.form));

        axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        }).post('/online-forms/applications/set-approver', formData).then((res) => {
          this.onSubmitSearch();
          setTimeout(() => {
            this.loadingModel = false;
            this.$q.notify({
              color: 'green-7',
              textColor: 'white',
              icon: 'fa fa-file-signature',
              message: 'Approver Has Been Set'
            });
          }, 1000);
        });
      }
    }
  }
}
</script>
<style lang="css" scoped>
</style>
